<template>
  <div>
    <section class="enkai__shops" v-if="isReady">
      <area-shops
        :prefecture="prefectureNameEn"
        :area="area"
        :area-detail="areaDetail"
        :station="station"
        :price_to="priceTo"
        :people_from="peopleFrom"
        :shop-type="shopType"
        @shopsCount="updateShopCount"
        @shops="updateShops"
      />
    </section>
    <section class="enkai__searchLinks">
      <search-location-links
        :prefecture-name="prefectureName"
        :prefecture-name-en="prefectureNameEn"
        :area="area"
        :area-detail="areaDetail"
        :station="station"
      />
    </section>
    <section class="enkai__faq" v-if="isPrefecturePage && shopsCount > 0">
      <area-faq
        :prefecture-name="prefectureName"
        :shopsCount="shopsCount"
        :shops="shops"
        :areas-in-prefecture="areasInPrefecture"
      />
    </section>
  </div>
</template>

<script>
import AreaShops from "./areaShops.vue";
import SearchLocationLinks from "./searchLocationLinks.vue";
import AreaFAQ from "./areaFAQ.vue";

export default {
    components: {
        'area-shops': AreaShops,
        'search-location-links': SearchLocationLinks,
        'area-faq': AreaFAQ
    },
    props: {
        prefectureName: {
            type: String,
            required: true
        },
        prefectureNameEn: {
            type: String,
            required: true
        },
        areasInPrefecture: {
            required: true,
            type: Array,
        },
        area: {
            required: false,
            type: Number,
            default: null
        },
        areaDetail: {
            required: false,
            type: Number,
            default: null
        },
        station: {
            required: false,
            type: Number,
            default: null
        },
        yenOrPeople: {
            required: false,
            type: String,
            default: null,
        },
        count: {
            required: false,
            type: Number,
            default: null
        },
        peopleCount: {
            required: false,
            type: Number,
            default: null
        },
        yenCount: {
            required: false,
            type: Number,
            default: null
        },
        shopType: {
            required: false,
            type: Number,
            default: null
        },
        isPrefecturePage: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            priceTo: null,
            peopleFrom: null,
            isReady: false,
            shopsCount: 0,
            shops: []
        }
    },
    created() {
        this.updatePriceAndPeople();
    },
    methods: {
        updatePriceAndPeople() {
            this.priceTo = this.yenOrPeople === 'yen' ? this.count : this.yenCount;
            this.peopleFrom = this.yenOrPeople === 'people' ? this.count : this.peopleCount;
            this.isReady = true;
        },
        updateShopCount(shopsCount) {
            this.shopsCount = shopsCount;
        },
        updateShops(shops) {
            this.shops = shops;
        }
    }
}
</script>